// Create new file: framework/common/schemas/collections/formSubmissions.js
import { z } from "zod";

const FormSubmissionSchema = z.object({
    _id: z.string().optional(),
    appName: z.string().describe("The name of the application from which the form was submitted."),
    name: z.string(),
    email: z.string().email(),
    subject: z.string(),
    message: z.string(),
    status: z.enum(['new', 'read', 'archived']).default('new'),
    createdAt: z.date().optional(),
});

export default FormSubmissionSchema;